import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { catalogItemActions } from 'entities/CatalogItem/model/slices/CatalogItemSlice';
import { PatchCatalogItemsResponse } from 'entities/CatalogItem/model/types/CatalogItemSchema';
import { set } from 'shared/lib/lodash/lodash';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

interface ChangeCatalogItemCategoryParams {
    catalogId: string;
    categoryId: string;
    itemIds: string[];
}

export const changeCatalogItemCategoryService = createAsyncThunk<
    PatchCatalogItemsResponse,
    ChangeCatalogItemCategoryParams,
    ThunkConfig<any>
>(
    'catalogItem/changeCategory',
    async ({ catalogId, categoryId, itemIds }, thunkApi) => {
        const { extra, rejectWithValue, dispatch } = thunkApi;

        if (!itemIds.length) {
            return rejectWithValue('error');
        }

        try {
            const response = await extra.api.patch<PatchCatalogItemsResponse>(
                `/v1/catalogs/${catalogId}/items`,
                {
                    items: itemIds.map((id) => ({ id, categoryId })),
                },
            );

            const dataToUpdate = {};
            response.data.patched.forEach((item) => {
                set(dataToUpdate, item.id, item);
            });

            dispatch(catalogItemActions.updateItems(dataToUpdate));

            toast('Category updated successfully.');

            return response.data;
        } catch (e) {
            return rejectWithValue('error');
        }
    },
);
